// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#principal[data-v-7ba5bd90] {\n    margin: 30px 0 0 !important;\n    /* margin-top: 0px;\n    margin-right: 0px;\n    margin-bottom: 0px;\n    margin-left: 0px; */\n}\n", ""]);
// Exports
module.exports = exports;
